import { render, staticRenderFns } from "./UsagesList.vue?vue&type=template&id=53692bf7&"
import script from "./UsagesList.vue?vue&type=script&lang=js&"
export * from "./UsagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports